export default __webpack_public_path__ + "static/media/porsche.e0d38880.svg";